export const accoutType = {
  // 已禁用
  STATUS_DISABLE: 0,
  // 待审核, 代理商
  STATUS_PENDING_CONFIRM: 1,
  // 代理商
  STATUS_AGENCY: 1,
  // 待验证
  STATUS_PENDING_VERIFIED: 2,
  // 审核失败/可再次申请
  STATUS_CONFIRM_FAIL: 3,
  // 已审核
  STATUS_ENABLE: 4,
  // 审核失败/最终状态
  STATUS_CONFIRM_FAIL_END: 5,
  // 修改审核
  STATUS_PENDING_CONFIRM_MODIFY: 6,
  // 修改审核失败
  STATUS_CONFIRM_MODIFY_FAIL: 7,
  // 限制
  STATUS_PUNISH: 8,
  // 等待CRM审核
  STATUS_WAIT_FOR_BPM_AUDIT: 9,
  // 自助开户待验证资质
  STATUS_SELF_SERVICE_UNAUDITED: 10,
  // 已审核,头像审核中
  // (没有落地到数据库,广告主的状态实际还是已审核)
  STATUS_ENABLE_AND_AVATAR_AUDITING: 11,
  // SMB客户待合同归档
  STATUS_WAIT_FOR_BPM_FILE_CONTACT: 12,
  // SMB广告主待缴纳开户费
  STATUS_WAIT_FOR_ACCOUNT_FEE: 13,
  // 待对公验证
  STATUS_WAIT_FOR_PUBLIC_AUTH: 14,
  // BM
  STATUS_BUSINESS_MANAGER: 99,
};

export const qualificationType = {
  MUSIC: 10, // 音乐资质
  MEDICINES: 11, // 医药资质
};

export const auditStatus = {
  /** 未提交资质 */
  NOT_SUBMIT: 0,
  /** 待审核 */
  NOT_STARTED: 1,
  /** 审核中 */
  UNDER_REVIEWING: 2,
  /** 审核通过 */
  APPROVAL: 3,
  /** 不通过 */
  REJECT: 4,
  /** 过期 */
  EXPIRE: 5,
  /** 失效 */
  INVALID: 6,
};

export const punishStatus = {
  ADMIN: 1, // 管理员惩罚
  AGENT: 2, // 代理商直接惩罚
  REFUND: 3, // 广告主退款惩罚
  AGENT_RELATE: 4, // 关联惩罚（因为代理商被惩罚，关联惩罚广告主）
  CREDIT_CARD_DEDUCTION_FAIL: 5, // 信用卡扣款失败惩罚
  OVERDUE_PAYMENT: 6, // 逾期欠款惩罚
  NON_TRADE_COMPLIANCE: 7, // 贸易合规惩罚
};
// 资质状态
export const aduitStatusMap = {
  // 拒审
  [auditStatus.REJECT]: {
    label: 'module_account_qualification_disapproved',
    value: 'reject',
  },
  // 过期
  [auditStatus.EXPIRE]: {
    label: 'module_account_qualification_expired',
    value: 'expire',
  },
  // 审核通过
  [auditStatus.APPROVAL]: {
    label: 'module_account_qualification_approved',
    value: 'approval',
  },
  // 审核中
  [auditStatus.UNDER_REVIEWING]: {
    label: 'module_account_qualification_in_review',
    value: 'under-reviewing',
  },
  // 草稿
  [auditStatus.NOT_SUBMIT]: {
    label: 'module_account_qualification_draft',
    value: 'not-submit',
  },
};

export const popupType = {
  CREATION_MODE_BTN: 'creation_mode_switch_weak_guide0',
  CLOSE_ARABIC_TIPS: 'account_banner_SA_field_illegal_confirm0',
  POST_INVOICE_CONFIRM: 'account_post_fulfill_info_confirm0',
  AD_MODE: 'creation_mode_switch_strong_guide0',
};
